const BASE_URL = '/api/integration-accounts';

async function fetchJson<T>(url: string, init?: RequestInit): Promise<T> {
  const response = await fetch(url, init);
  if (!response.ok) {
    const body = await response.json().catch(() => ({ error: response.statusText }));
    throw new Error(body.error?.message ?? body.error ?? `Request failed: ${response.status}`);
  }
  return response.json() as Promise<T>;
}

export type IntegrationType = 'google-ads' | 'google-analytics' | 'instagram';

export interface IntegrationAccount {
  id: number;
  integration_type: IntegrationType;
  google_account_id: number | null;
  google_email: string | null;
  google_alias: string | null;
  config: Record<string, string>;
  created_at: string;
  updated_at: string;
}

export async function listIntegrationAccounts(): Promise<IntegrationAccount[]> {
  return fetchJson<IntegrationAccount[]>(BASE_URL);
}

export async function upsertIntegrationAccount(type: IntegrationType, data: {
  google_account_id?: number | null;
  config?: Record<string, string>;
}): Promise<void> {
  await fetchJson(`${BASE_URL}/${type}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });
}

export async function deleteIntegrationAccount(type: IntegrationType): Promise<void> {
  await fetchJson(`${BASE_URL}/${type}`, { method: 'DELETE' });
}
